import { atom } from 'jotai';

/**
 * Which numeric panel is open: one at a time, and none unless asked for, so
 * the 3D result stays in view (owner, 2026-10-30). Each closes again when its
 * tool goes away (the clip box rows unmount, the surface tool leaves adjust).
 */
export const numericPanelAtom = atom<'clipBox' | 'surface' | null>(null);

/** An open-state atom for one panel: true = open (closing the other), false = close if it is this one. */
export const panelOpenAtom = (which: 'clipBox' | 'surface') =>
  atom(
    (get) => get(numericPanelAtom) === which,
    (get, set, next: boolean | ((open: boolean) => boolean)) => {
      const open = get(numericPanelAtom) === which;
      const v = typeof next === 'function' ? next(open) : next;
      if (v) set(numericPanelAtom, which);
      else if (open) set(numericPanelAtom, null);
    },
  );

/**
 * "Align to 2 points" (GIS-443): null = not picking; else the points picked so
 * far (0 or 1). While armed the clip box shows the whole cloud and offers no
 * handles, so the clicks reach the cloud (`ClipBoxTool`, `ClipBoxAlignPicker`).
 */
export const clipBoxAlignPickAtom = atom<Array<[number, number, number]> | null>(null);
